import React from "react";

const QuizResult = (props) => {
  return (
    <>
      <div className="show-score" style={{fontWeight: '800'}}>
        Your Score: {props.score}/{props.totalQuestion}
      </div>
      <button
        type="button"
        className="btn btn-outline-success"
        style={{ width: "120px", fontSize: "18px", fontWeight: "700", marginTop: '200px'}}
        onClick={props.tryAgain}>
        Try Again
      </button>
    </>
  );
};

export default QuizResult;
